// ** Third Party Components
import styled, { css } from "styled-components";

// ** Styles Import
import DynamicHeartIcon from "components/icons/DynamicHeartIcon";
import DynamicCommentIcon from "components/icons/DynamicCommentIcon";

import Block from "./Block";

const StyledActionButton = styled.button`
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	align-self: start;
	margin: 0 0 0 0.5rem;
	padding: 0 0.6rem;
	height: ${({ isSmall, isUserGalleryProfile }) =>
		isUserGalleryProfile ? "21px" : isSmall ? "25px" : "35px"};
	background-color: transparent;

	cursor: default;

	${({ customMargin }) => {
		return (
			customMargin &&
			css`
				margin: ${customMargin};
			`
		);
	}}

	${({ $customPadding }) => {
		return (
			$customPadding &&
			css`
				padding: ${$customPadding};
			`
		);
	}}


	color: ${({ theme: { colors } }) => colors.grey};
	svg {
		fill: ${({ theme: { colors } }) => colors.grey};
	}
`;

export const FakeActionButton = ({
	isHeart,
	isComment,
	isPen,
	isTrash,
	label = null,
	labelSize = "14px",
	isUserGalleryProfile,
	customSvgSize,
	customMargin,
	customPadding,
	customMarginLeft,
}) => {
	return (
		<StyledActionButton
			isHeart={isHeart}
			isComment={isComment}
			isTrash={isTrash}
			isPen={isPen}
			customMargin={customMargin}
			$customPadding={customPadding}
			isSmall={
				customSvgSize === "11px" ||
				customSvgSize === "13px" ||
				customSvgSize === "14px" ||
				customSvgSize === "15px"
			}
			isUserGalleryProfile={isUserGalleryProfile}
		>
			<Block flex alignCenter relative>
				{isHeart && <DynamicHeartIcon height={customSvgSize} />}
				{isComment && <DynamicCommentIcon height={customSvgSize} />}
				{label && (
					<div
						style={{
							marginLeft: customMarginLeft
								? customMarginLeft
								: "5px",
							fontSize: labelSize ? labelSize : "14px",
							lineHeight: 0.9,
						}}
					>
						{label}
					</div>
				)}
			</Block>
		</StyledActionButton>
	);
};
